// removed by extract-text-webpack-plugin
module.exports = {"background":"src-display-modules-Home-Guide-index__background--3J3qi","guide":"src-display-modules-Home-Guide-index__guide--2aXy3","guideSingle":"src-display-modules-Home-Guide-index__guideSingle--VqEhB","panel":"src-display-modules-Home-Guide-index__panel--3wm4s","next":"src-display-modules-Home-Guide-index__next--3VVBP","pageInfo":"src-display-modules-Home-Guide-index__pageInfo--3lA1P","page":"src-display-modules-Home-Guide-index__page--3rwR4","submit":"src-display-modules-Home-Guide-index__submit--14KNF","cancel":"src-display-modules-Home-Guide-index__cancel--AvU7n"};


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Guide/index.scss
// module id = 421
// module chunks = 0